import { Link } from 'react-router-dom';
import { PACKAGES, CUSTOM_PROJECTS } from '../constants/packages';
import blockchainIcon from '../assets/logos-brands/blockchain-icon.svg';

const CheckIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0, marginTop: 2 }}>
    <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PricingCard = ({ package: pkg }) => (
  <div className={`pt-card ${pkg.highlighted ? 'pt-card--featured' : ''}`}>
    {pkg.highlighted && <div className="pt-featured-bar" />}

    <div className="pt-card-head">
      <span className="pt-tier">TIER {pkg.tier}</span>
      <h3 className="pt-name">{pkg.name}</h3>
      <p className="pt-subtitle">{pkg.subtitle}</p>
    </div>

    <div className="pt-price-block">
      <div className="pt-price">{pkg.price}</div>
      <div className="pt-price-note">{pkg.priceNote}</div>
    </div>

    <Link to={pkg.ctaLink} className={`pt-cta ${pkg.highlighted ? 'pt-cta--featured' : ''}`}>
      {pkg.cta}
    </Link>

    <div className="pt-divider" />

    <p className="pt-desc">{pkg.description}</p>

    <ul className="pt-features">
      {pkg.features.map((f, i) => (
        <li key={i} className="pt-feature">
          <CheckIcon />
          <span>{f}</span>
        </li>
      ))}
    </ul>
  </div>
);

const Packages = () => {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="pt-section" id="packages">
      <div className="packages-pulse" aria-hidden="true">
        <svg viewBox="0 0 1200 400" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="packages-pulse-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#8b5cf6" stopOpacity="0" />
              <stop offset="40%" stopColor="#8b5cf6" stopOpacity="1" />
              <stop offset="70%" stopColor="#3b82f6" stopOpacity="1" />
              <stop offset="100%" stopColor="#06b6d4" stopOpacity="0" />
            </linearGradient>
            <filter id="packages-pulse-glow">
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
            </filter>
          </defs>
          <path className="packages-pulse-line" d="M1150 50 L750 50 Q680 50 680 120 L680 230 Q680 300 610 300 L200 300" />
          <path className="packages-pulse-line packages-pulse-line-secondary" d="M1150 100 L800 100 Q730 100 730 170 L730 260 Q730 330 660 330 L150 330" />
          <path className="packages-pulse-glow" d="M1150 50 L750 50 Q680 50 680 120 L680 230 Q680 300 610 300 L200 300" />
        </svg>
      </div>

      <div className="pt-header">
        <p className="pt-eyebrow">Engagement Tiers</p>
        <h2 className="pt-heading">Transparent starting points.</h2>
        <p className="pt-subheading">
          Most projects are scoped custom — these give you a sense of scale and what's included.
        </p>
      </div>

      <div className="pt-grid">
        {PACKAGES.map(pkg => (
          <PricingCard key={pkg.id} package={pkg} />
        ))}
      </div>

      <div className="pt-enterprise">
        <img src={blockchainIcon} alt="" className="pt-enterprise-icon" aria-hidden="true" />
        <div className="pt-enterprise-text">
          <p className="pt-enterprise-title">{CUSTOM_PROJECTS.title}</p>
          <p className="pt-enterprise-desc">{CUSTOM_PROJECTS.description}</p>
        </div>
        <button className="pt-enterprise-cta" onClick={scrollToContact}>
          {CUSTOM_PROJECTS.cta} →
        </button>
      </div>
    </section>
  );
};

export default Packages;
